import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region ../icons/dist/react/minimal/cast-exit.js
const CastExitIcon = (props, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "currentColor",
	"aria-hidden": "true",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: [
		/* @__PURE__ */ jsx("path", { d: "M15.154 2.004A3 3 0 0 1 18 5v8l-.004.154a3 3 0 0 1-2.842 2.842L15 16H7.5q-.002-.772-.15-1.5H15a1.5 1.5 0 0 0 1.5-1.5V5A1.5 1.5 0 0 0 15 3.5H3A1.5 1.5 0 0 0 1.5 5v3.65A7.5 7.5 0 0 0 0 8.5V5a3 3 0 0 1 3-3h12z" }),
		/* @__PURE__ */ jsx("path", { d: "M14 5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H6.874A7.52 7.52 0 0 0 3 9.126V6a1 1 0 0 1 1-1zM0 12a4 4 0 0 1 4 4H2.5A2.5 2.5 0 0 0 0 13.5z" }),
		/* @__PURE__ */ jsx("path", { d: "M0 9.5A6.5 6.5 0 0 1 6.5 16H5a5 5 0 0 0-5-5zm0 5A1.5 1.5 0 0 1 1.5 16h-1a.5.5 0 0 1-.5-.5z" })
	]
});
const ForwardRef = forwardRef(CastExitIcon);
//#endregion
export { ForwardRef as default };

//# sourceMappingURL=cast-exit.js.map